
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 500 500","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.456 398.314c0 14.611 5.817 28.604 16.105 38.931a55.092 55.092 0 0038.931 16.115h330.313a55.076 55.076 0 0038.932-16.115 55.147 55.147 0 0016.114-38.931V164.357c0-14.58-5.816-28.604-16.114-38.931a55.076 55.076 0 00-38.932-16.115H263.931c-49.031 0-41.283-68.8-116.097-68.8H57.492a55.092 55.092 0 00-38.931 16.115C8.273 66.954 2.456 80.947 2.456 95.557v302.757z","fill":"#8486D3"}}),_c('path',{attrs:{"d":"M447.453 164.357H357.15c-74.814 0-74.067 68.8-123.097 68.8H110.176c-30.395 0-57.524 24.679-60.622 55.076l-6.772 53.312-7.22 56.769-.261-.031c-1.602 8.337-9.251 13.765-17.916 13.765-8.824 0-15.197-7.002-14.77-15.726-.029.657-.159 1.305-.159 1.992a55.093 55.093 0 0013.326 35.794 55.133 55.133 0 0033.474 18.434 38.75 38.75 0 008.236.818h357.832c30.406 0 57.565-24.65 60.633-55.046l20.984-178.911c3.078-30.407-19.082-55.046-49.488-55.046z","fill":"#C0C2FF"}})])
          )
        }
      }
    